// Utilities extracted from LoginModule.js

import _ from "lodash";
import axios from "lib/axiosInstance";
import { initGA, getBackendServerUrl, getMemoizedFunction } from "Utils";
import {
  loadIntercom,
  resetIntercomRuntime,
  configureIntercom,
  hideIntercom,
} from "lib/intercom";
import { loadVitally } from "lib/vitally";
import {
  DUMMY_USER_INFO,
  PUBLIC_USER_INFO_EU_WEST_1,
  PUBLIC_USER_INFO_US_EAST_1,
  PUBLIC_USER_INFO_AP_SOUTH_EAST_2,
  PUBLIC_USER_INFO_ME_CENTRAL_1,
  PUBLIC_USER_INFO_EU_CENTRAL_1,
  mypConfig,
  ubdConfig,
  mbConfig,
  USER_TYPE_ENTITY_MAPPING,
  CURRICULUM_TYPE_ORDER_MAPPING,
  CURRICULUM_PLAN_ORDER_MAPPING,
  CURRICULUM_PLAN_LABEL_MAPPING_FOR_EXTERNAL_API,
  VITALLY_NPS,
  PUBLIC_USER_INFO_AP_SOUTH_EAST_1,
  GOOGLE_CLIENT_ID,
  MICROSOFT_SCOPES,
  MICROSOFT_CLIENT_ID,
  intercomAUSAppId,
  intercomUSAppId,
  intercomApiBaseForIntercomAUS,
  intercomApiBaseForIntercomUS,
} from "Constants";
import {
  getUserInfofromStorage,
  getOrgWorkSpaceDetailsFromStorage,
} from "services/localStorage";
import i18next from "lib/i18n";
import { decodeFromBase64 } from "Utils/StringHelpers";
import {
  enableGoogleAnalytics,
  enableNewLoginFlow,
  disablePwdInParentSignup,
  enableSamlLoginFlow,
  enablePasswordLogin,
  enableLoginFlowV2,
} from "config";
import {
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  CLOSE_SENTRAL_PORTAL_IFRAME,
} from "Constants/stringConstants";
import { store } from "store/createStore";
import {
  getIsIntercomAusWorkspaceEnabled,
  showGlobalHeaderInLibrary,
  getIsIntercomV2Enabled,
} from "Utils/ACLStoreUtils";
import { isLibraryResourceRoute } from "Utils/RouteMatchUtils";
import { setUnderMaintenance } from "./LoginActions";

/* export const initLogRocket = options => {
  try {
    // console.log("init log rocket");
    if (__PROD__) {
      LogRocket.init("toddle/toddle-teacher-portal", options);
    }
    if (__STAGING__) {
      LogRocket.init("mbqrca/tod-staging", options);
    }
  } catch (e) {}
}; */

//------BELOW CODE COULD BE USEFUL IN FUTURE------
// Below methods help to manage selectedAcademicYearId in local storage
/*
export const manageAcademicYear = {
  getFromLocalStorage: () => {
    const storageData = getUserInfofromStorage() || {};
    return _.get(storageData, "selectedAcademicYearId", "");
  },
  setInLocalStorage: academicYearId => {
    const storageData = getUserInfofromStorage() || {};
    const newStorageData = {
      ...storageData,
      selectedAcademicYearId: academicYearId,
    };
    setUserInfoInStorage(newStorageData);
  },
  resetToNullInLocalStorage: () => {
    const storageData = getUserInfofromStorage() || {};
    const newStorageData = {
      ...storageData,
      selectedAcademicYearId: null,
    };
    setUserInfoInStorage(newStorageData);
  },
};
*/

export const initAllThirdPartyModules = () => {
  i18next();
  //initGoogleAnalytics();
  // initLogRocket();
  // initMixPanel();
  loadIntercom();
  if (VITALLY_NPS.isEnabled) loadVitally();
};

export const initGoogleAnalytics = () => {
  if (enableGoogleAnalytics) {
    initGA();
  }
};

const _getIntercomAppConfig = () => {
  const state = store.getState();

  const userInfo = _.get(state, "login.userInfo") ?? getUserInfofromStorage();

  const orgRegion = userInfo?.orgRegion || "eu-west-1";

  switch (orgRegion) {
    case "ap-southeast-2": {
      if (getIsIntercomAusWorkspaceEnabled()) {
        return {
          app_id: intercomAUSAppId,
          api_base: intercomApiBaseForIntercomAUS,
        };
      }

      return {
        app_id: intercomUSAppId,
        api_base: intercomApiBaseForIntercomUS,
      };
    }

    default: {
      return {
        app_id: intercomUSAppId,
        api_base: intercomApiBaseForIntercomUS,
      };
    }
  }
};

export const setupIntercom = (settings = {}) => {
  const intercomAppConfig = _getIntercomAppConfig();

  try {
    configureIntercom(intercomAppConfig, settings);

    if (getIsIntercomV2Enabled()) {
      hideIntercom();
    }
  } catch (e) {}
};

export const starChatWidgetForVisitors = () => {
  if (window.Intercom) {
    window.Intercom("boot", {
      app_id: intercomUSAppId,
    });
  }
};

export const starChatWidget = ({
  intercom_user_jwt,
  Is_IB_PYP,
  Is_IB_MYP,
  Is_UBD,
  Is_IB_Evaluator,
  CURRICULUM_PROGRAMS_WITH_PLAN,
}) => {
  setupIntercom({
    intercom_user_jwt,
    Is_IB_PYP,
    Is_UBD,
    Is_IB_MYP,
    Is_IB_Evaluator,
    CURRICULUM_PROGRAMS_WITH_PLAN,
  });
};

export const openChat = () => {
  if (window.Intercom) {
    window.Intercom("show");
  }
};

function stopChatWidget() {
  resetIntercomRuntime();
}

export const openNewConversation = prefilledMessage => {
  if (window.Intercom) {
    window.Intercom("showNewMessage", prefilledMessage);
  }
};

export const removeQueryParam = (url, paramToRemove) => {
  // Create a URLSearchParams object with the query string of the URL
  const [baseUrl, queryParams] = _.split(url, "?");
  var searchParams = new URLSearchParams(queryParams);

  // Delete the parameter to remove
  searchParams.delete(paramToRemove);

  // Reconstruct the URL with the updated search parameters
  var updatedUrl = baseUrl + "?" + searchParams.toString();

  return updatedUrl;
};

export const hasQueryParam = (_url = window.location.href, paramToCheck) => {
  const url = new URL(_url);
  const params = new URLSearchParams(url.search);
  if (params.has(paramToCheck)) {
    return true;
  } else {
    return false;
  }
};

export const isUserLoggedOut = () => {
  /**
   * User is considered to be logged out, when one of following is true
   * 1. There is no user info in localStorage
   * 2. User is community public user
   * 3. User has opened organization switcher screen and has not selected any organization(identity)
   */

  //1. There is no user info in localStorage
  const userInfo = getUserInfofromStorage();
  if (_.isEmpty(userInfo)) return true;

  //2. User is community public user
  const { id, portalType } = userInfo;
  const isCommunityPublicUser =
    portalType === DUMMY_USER_INFO.portalType && id === DUMMY_USER_INFO.id;
  if (isCommunityPublicUser) return true;

  //3. User has opened organization switcher screen and has not selected any organization(identity)
  const isIdentitySelected = _.has(userInfo, "isIdentitySelected")
    ? userInfo["isIdentitySelected"]
    : true;

  return !isIdentitySelected;
};

export const isSettingEnabled = ({
  settings,
  settingName,
  valueCheck = false,
}) => {
  const value = _.get(
    _.find(settings, item => item.name == settingName),
    "value",
    "false"
  );

  if (!valueCheck) {
    return !value || value == "false" ? true : false;
  } else {
    return (value && value != "false") || value == "true" ? true : false;
  }
};

const getSubscriptionPlanDetails = params => {
  //Shallow copy is required as Array.sort mutates original array
  const curriculumPrograms = [...(params.curriculumPrograms ?? [])];

  const sortedCurriculumPrograms = curriculumPrograms.sort(
    (firstCurriculum, secondCurriculum) => {
      const firstCurriculumOrder =
        CURRICULUM_TYPE_ORDER_MAPPING[firstCurriculum.type];

      const secondCurriculumOrder =
        CURRICULUM_TYPE_ORDER_MAPPING[secondCurriculum.type];

      if (firstCurriculumOrder === secondCurriculumOrder) {
        const firstCurriculumSubscriptionPlanType = _.get(
          firstCurriculum,
          "subscriptionPlan.type"
        );

        const secondCurriculumSubscriptionPlanType = _.get(
          secondCurriculum,
          "subscriptionPlan.type"
        );

        return (
          CURRICULUM_PLAN_ORDER_MAPPING[firstCurriculumSubscriptionPlanType] -
          CURRICULUM_PLAN_ORDER_MAPPING[secondCurriculumSubscriptionPlanType]
        );
      }

      return firstCurriculumOrder - secondCurriculumOrder;
    }
  );

  const curriculumProgramWithPlans = _.join(
    _.uniq(
      _.map(sortedCurriculumPrograms, ({ type, subscriptionPlan }) => {
        const { type: subscriptionPlanType } = subscriptionPlan;
        return `${type}_${CURRICULUM_PLAN_LABEL_MAPPING_FOR_EXTERNAL_API[subscriptionPlanType]}`;
      })
    ),
    ","
  );

  return {
    curriculumProgramWithPlans,
  };
};

const getCurriculumProgramWithPlansPayload = ({
  userCurriculumPrograms,
  curriculumPrograms,
}) => {
  let updatedUserCurriculumPrograms = [...(userCurriculumPrograms ?? [])];

  /** Assuming that if user doesn't belong to any course,
   *   he/she is part of all curriculum programs  */
  if (_.isEmpty(updatedUserCurriculumPrograms)) {
    updatedUserCurriculumPrograms = curriculumPrograms;
  }

  const userCurriculumProgramTypes = _.map(
    updatedUserCurriculumPrograms,
    ({ type }) => type
  );

  const { curriculumProgramWithPlans } = getSubscriptionPlanDetails({
    curriculumPrograms: userCurriculumPrograms,
  });

  const Is_IB_PYP = _.includes(userCurriculumProgramTypes, CURRICULUM_TYPE_PYP);
  const Is_IB_MYP = _.includes(userCurriculumProgramTypes, CURRICULUM_TYPE_MYP);
  const Is_UBD = _.includes(userCurriculumProgramTypes, CURRICULUM_TYPE_UBD);

  const curriculumProgramWithPlansPayload = {
    CURRICULUM_PROGRAMS_WITH_PLAN: curriculumProgramWithPlans,
  };

  return {
    Is_IB_PYP,
    Is_IB_MYP,
    Is_UBD,
    ...curriculumProgramWithPlansPayload,
  };
};

export const getUserDetailsForStorage = ({
  staffDetails = {},
  organization,
}) => {
  const userType =
    _.get(staffDetails, "type", "staff") || staffDetails.user_type;
  const userInfoStorage = getUserInfofromStorage();
  return {
    id: _.get(staffDetails, "id", ""),
    first_name: staffDetails.firstName || staffDetails.first_name,
    middle_name:
      staffDetails.middleName || _.get(staffDetails, "middle_name", ""),
    last_name: staffDetails.lastName || staffDetails.last_name,
    preferred_name:
      staffDetails.preferredName || _.get(staffDetails, "preferred_name", ""),
    pronouns: _.get(staffDetails, "pronouns", ""),
    prefix: _.get(staffDetails, "prefix", ""),
    suffix: _.get(staffDetails, "suffix", ""),
    email: staffDetails.email,
    profile_image: staffDetails.profileImage || staffDetails.profile_image,
    designation: _.get(staffDetails, "designation.title", ""),
    token: staffDetails.jwt,
    org_id: _.get(organization, "id", "") || staffDetails.org_id,
    jwt: _.get(staffDetails, "jwt", ""),
    intercom_user_jwt: _.get(staffDetails, "intercomJwt", ""),
    //TODO: remove this field when curriculum program subscription plan is enabled
    orgIsFree: _.get(organization, "tier.isFree", false),
    user_type: _.get(staffDetails, "type", "staff") || staffDetails.user_type,
    userEntityType: _.get(USER_TYPE_ENTITY_MAPPING[userType], "entityType", ""),
    isDevUser: _.get(staffDetails, "isDevUser", false),
    identityId: _.get(staffDetails, "identityId")
      ? _.get(staffDetails, "identityId")
      : _.get(userInfoStorage, "identityId"),
  };
};

export const isToddleLibraryRoute = () => {
  return _.includes(window.location.href, "/toddle-library");
};

const _isMypUbdLibraryRoute = routeCourseId => {
  const toddleLibraryOrgs = getSampleOrgConfig();
  return routeCourseId
    ? _.some(toddleLibraryOrgs, ({ demoCourse }) => demoCourse == routeCourseId)
    : false;
};

export const isMypUbdLibraryRoute = getMemoizedFunction(_isMypUbdLibraryRoute);

export const isLibraryRoute = routeCourseId => {
  return isToddleLibraryRoute() || isMypUbdLibraryRoute(routeCourseId);
};

const getUserInfoMemo = _.memoize(
  ({ portalUserInfo, userInfo, portalType, userIdentityDetails }) => {
    return {
      ...(portalUserInfo || userInfo || {}),
      portalType,
      userIdentityDetails,
    };
  },
  ({ portalUserInfo, userInfo, portalType, userIdentityDetails }) => {
    const id = _.get(portalUserInfo, "id", _.get(userInfo, "id", ""));
    const type = _.get(
      portalUserInfo,
      "user_type",
      _.get(userInfo, "user_type", "")
    );
    const org_id = _.get(userInfo, "org_id", "COMMUNITY");
    const token = _.get(userInfo, "token", "");
    const tags = _.get(userInfo, "tags", _.get(portalUserInfo, "tags", []));
    const role = _.get(userInfo, "role", _.get(portalUserInfo, "role", ""));
    const childID = _.get(userInfo, "childID", "");
    const isChildBlocked = _.get(userInfo, "isChildBlocked", false);
    const childBlockedMessage = _.get(userInfo, "childBlockedMessage", "");
    const isDevUser = _.get(userInfo, "isDevUser", "");
    const userEntityType = _.get(userInfo, "userEntityType", "");
    const orgPlan = _.get(userInfo, "orgPlan", "");
    const region = _.get(userInfo, "region", "");
    const projectGroups = _.get(userInfo, "projectGroups", "");
    const userCurriculumProgramIds = _.map(
      _.get(userInfo, "userCurriculumPrograms", []),
      "id"
    );
    const idpCode = _.get(userInfo, "idpCode", "");

    return JSON.stringify({
      id,
      type,
      org_id,
      portalType,
      tags,
      role,
      userIdentityDetails,
      childID,
      isDevUser,
      userEntityType,
      orgPlan,
      region,
      projectGroups,
      isChildBlocked,
      childBlockedMessage,
      token,
      userCurriculumProgramIds,
      idpCode,
    });
  }
);

export const getUserInfo = ({ portalType } = {}) => {
  const state = store.getState();
  const userInfo = _.get(state, "login.userInfo") ?? getUserInfofromStorage();
  const publicToken = _.get(state, "login.publicToken");
  const userIdentityDetails = _.get(state, "login.userIdentityDetails", []);
  let portalUserInfo = null;

  if (isToddleLibraryRoute()) {
    /**
     * - If portal type is not passed and is a library resource route (LE/Unit/Worksheet/Question), set portalType to "COMMUNITY".
     * - The permission check "showGlobalHeaderInLibrary()" is for old behavior
     *   where portalType "COMMUNITY" is passed in all the library queries if portalType is undefined
     */
    const setCommunityPortalType =
      !portalType && (!showGlobalHeaderInLibrary() || isLibraryResourceRoute());

    if (setCommunityPortalType) {
      portalType = "COMMUNITY";
    }
    if (_.isEmpty(userInfo)) {
      portalUserInfo = {
        ...DUMMY_USER_INFO,
        token: publicToken,
        jwt: publicToken,
      };
    }
  }

  if (isPublicPlatformRoute()) {
    return `Bearer ${publicToken}`;
  }

  //Handled only for staff. Because userIdentityDetails is not exposed for student
  if (
    !!portalType &&
    _.isEmpty(portalUserInfo) &&
    userInfo.user_type == "staff"
  ) {
    portalUserInfo = _.find(
      userIdentityDetails,
      item => item.portalType == portalType
    );
    if (!_.isEmpty(portalUserInfo) && !_.has(portalUserInfo, ["user_type"])) {
      portalUserInfo["user_type"] = "staff";
      portalUserInfo["userEntityType"] = "STAFF";
    }

    if (!_.isEmpty(portalUserInfo) && userInfo?.idpCode) {
      portalUserInfo["idpCode"] = userInfo.idpCode;
    }
  }

  return getUserInfoMemo({
    portalUserInfo,
    userInfo,
    portalType,
    userIdentityDetails,
  });
};

export const getOrgWorkSpaceDetails = () => {
  const state = store.getState();

  let orgWorkspaceDetails = _.get(state, "login.orgWorkspaceDetails");

  // state is empty then get details from localstorage
  if (_.isNil(orgWorkspaceDetails.organizationId)) {
    orgWorkspaceDetails = getOrgWorkSpaceDetailsFromStorage();
  }

  return orgWorkspaceDetails;
};

export const decodeLocationContext = url => {
  const redirectUrlParams = new URL(url).searchParams;
  if (
    redirectUrlParams.get("source") !== "email" ||
    !redirectUrlParams.get("locationContext")
  ) {
    return null;
  }
  // Step 2: Decode from Base64
  const base64Decoded = decodeFromBase64(
    redirectUrlParams.get("locationContext")
  );

  // Step 3: Parse JSON data
  const locationContext = JSON.parse(base64Decoded);

  // Step 4: If metadata is a stringified JSON, parse it too
  if (typeof locationContext.metadata === "string") {
    locationContext.metadata = JSON.parse(locationContext.metadata);
  }

  // Family invite emails now use locationContext with source=email format
  // Skip processing invite_family types here
  if (_.get(locationContext, "type", "") === "invite_family") {
    return null;
  }

  return locationContext;
};

export const extractDataFromEmailRedirectionUrl = url => {
  try {
    const urlParams = new URL(url).searchParams;

    const encodedLocationContext = urlParams.get("redirect_url");
    if (!encodedLocationContext) {
      return null;
    }

    // Step 1: Decode from URL encoding
    const urlDecoded = decodeURIComponent(encodedLocationContext);
    return decodeLocationContext(urlDecoded);
  } catch (error) {
    console.error("Error decoding locationContext:", error);
    return null;
  }
};

export const isUserBlockedRoute = () => {
  return _.includes(window.location.href, "/user-blocked");
};

export const isSessionRevokeRoute = () => {
  return _.includes(window.location.href, "/session-revoke");
};

export const isPublicPlatformRoute = () => {
  return (
    _.includes(window.location.href, "platform/public") &&
    !isPublicPlatformPostRoute()
  );
};

export const isPublicPlatformPostRoute = () => {
  return _.includes(window.location.href, "platform/public/post");
};

export const isPageNotFoundRoute = () => {
  return _.includes(window.location.href, "/page-not-found");
};

export const isMigrationInProgressRoute = () => {
  return _.includes(window.location.href, "/migration-in-progress");
};

export const isPublicSSORoute = () => {
  return (
    _.includes(window.location.href, "/sso") &&
    !_.includes(window.location.href, "/sso/canny")
  );
};

export const isPublicSchoolLoginPage = () => {
  return _.includes(window.location.href, "/account");
};

export const isPublicToddleAppLaunchRoute = () => {
  return _.includes(window.location.href, "/launch-app");
};

export const isPublicAppDownloadRoute = () => {
  return _.includes(window.location.href, "/app-download");
};

export const isPublicMobileUnsupportedRoute = () => {
  return _.includes(window.location.href, "/redirect");
};

export const getQueryParams = () => {
  return new URLSearchParams(window.location.search);
};

export const getSampleOrgConfig = () => {
  return [mypConfig, ubdConfig, mbConfig];
};

export const isAdministratorRoute = () => {
  return _.includes(window.location.href, "/administrator");
};

export const getSampleOrgPortalType = ({ courseId }) => {
  const sampleUnitCourse = getSampleOrgConfig();
  if (!_.isEmpty(sampleUnitCourse)) {
    const sampleUnitPortalType = _.get(
      _.find(sampleUnitCourse, course => course.demoCourse == courseId),
      "portalType",
      null
    );
    return sampleUnitPortalType;
  }
};

export const getIsNewLoginFlowEnabled = ({ userType }) => {
  return window.__ENABLE_NEW_LOGIN_FLOW__
    ? window.__ENABLE_NEW_LOGIN_FLOW__[userType]
    : enableNewLoginFlow[userType];
};

export const getIsPwdDisabledInParentSignup = () => {
  return window.__DISABLE_PWD_IN_PARENT_SIGNUP__
    ? window.__DISABLE_PWD_IN_PARENT_SIGNUP__
    : disablePwdInParentSignup;
};

export const getIsSamlLoginEnabled = ({ userType }) => {
  return enableSamlLoginFlow ? enableSamlLoginFlow[userType] : false;
};

export const getIsPasswordloginEnabled = ({ userType }) => {
  return enablePasswordLogin ? enablePasswordLogin[userType] : false;
};

export const getIsLoginFlowEnabledV2 = ({ userType }) => {
  return enableLoginFlowV2 ? enableLoginFlowV2[userType] : false;
};

export const getLoginDataState = ({ userType, role }) => {
  switch (userType) {
    case "staff":
      if (role === "visitor") {
        return "visitorLogin";
      }
      return "teacherLogin";
    case "parent":
      return "parentLogin";
    case "student":
      return "loginFormV2";
  }
};

export const checkIsPYPCoordinator = ({ role, designation }) => {
  return designation.toString() == "2";
};

/**It will check whether user account exists
 * or user has reset password or not*/
export const isUserAccountExists = async ({ email, region }) => {
  try {
    const requestObj = {
      email,
      userSource: "VISITOR_INVITE_EMAIL",
      region,
    };

    const response = await axios.post(
      getBackendServerUrl({
        path: "/auth/v2/signUp/verifyDomain",
      }),
      requestObj
    );
    const data = _.get(response, "data", {});
    return data;
  } catch (e) {
    console.error(e);
  }
};

export const fetchOrganizationAndUserIdForPublicPost = () => {
  const query = getQueryParams();
  switch (query.get("region")) {
    case "us-east-1":
      return {
        organizationId: PUBLIC_USER_INFO_US_EAST_1.org_id,
        userId: PUBLIC_USER_INFO_US_EAST_1.id,
      };
    case "ap-southeast-2":
      return {
        organizationId: PUBLIC_USER_INFO_AP_SOUTH_EAST_2.org_id,
        userId: PUBLIC_USER_INFO_AP_SOUTH_EAST_2.id,
      };
    case "ap-southeast-1":
      return {
        organizationId: PUBLIC_USER_INFO_AP_SOUTH_EAST_1.org_id,
        userId: PUBLIC_USER_INFO_AP_SOUTH_EAST_1.id,
      };
    case "me-central-1":
      return {
        organizationId: PUBLIC_USER_INFO_ME_CENTRAL_1.org_id,
        userId: PUBLIC_USER_INFO_ME_CENTRAL_1.id,
      };
    case "eu-central-1":
      return {
        organizationId: PUBLIC_USER_INFO_EU_CENTRAL_1.org_id,
        userId: PUBLIC_USER_INFO_EU_CENTRAL_1.id,
      };
    default:
      return {
        organizationId: PUBLIC_USER_INFO_EU_WEST_1.org_id,
        userId: PUBLIC_USER_INFO_EU_WEST_1.id,
      };
  }
};

export const getPublicToken = async ({ type }) => {
  try {
    const query = getQueryParams();
    const region = query.get("region") ?? "eu-west-1";
    const response = await axios.post(
      getBackendServerUrl({ region, path: "/auth/public-token" }),
      { type, region }
    );
    const { token } = response.data;
    return token;
  } catch (e) {
    console.error(e);
  }
};

//Note:Utility Function to get region for public entity where region is not correct
export const getRegionForPublicEntity = async ({ entityType }) => {
  try {
    const query = getQueryParams();
    const region = query.get("region") ?? "eu-west-1";
    const response = await axios.post(
      getBackendServerUrl({ region, path: "/auth/publicEntityRegion" }),
      {
        url: window.location.href,
        entityType,
      }
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getSamlBackendRedirectUrl = ({
  region,
  idpId,
  userType,
  schoolCode,
}) => {
  const url = getBackendServerUrl({
    path: `/auth/v2/saml/callIdpSSO?idpCode=${idpId}&userType=${userType}&schoolCode=${schoolCode}`,
  });
  return `${url}`;
};

/**
 *
 * @param {*} serviceType
 * @description get access token and redirect to base url with access token without opening new tab
 */
export const openSelfLoginWindow = serviceType => {
  const urlParams = new URLSearchParams(window.location.search);
  const userType = urlParams.get("usertype");

  // * Third parth auth account scope
  const SCOPES = {
    GOOGLE: "profile email",
    MICROSOFT: MICROSOFT_SCOPES,
  };

  // * Third parth auth method
  const METHODS = {
    GOOGLE: "googleV2",
    MICROSOFT: "microsoft",
  };

  // * Third parth auth Base URL
  const BASE_URLS = {
    GOOGLE: "https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount",
    MICROSOFT: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
  };

  // * Common state params to access in redirect uri for further action on success/error
  const commonStateParams = {
    mode: "kiosk",
    userType: userType,
    type: urlParams.get("type"),
    redirectUrl: window.location.href,
    method: _.get(METHODS, serviceType),
  };

  // * Generate Third party oauth UI url, with select account prompt
  const generateURL = _queryParams => {
    const queryParams = _.merge(_queryParams, {
      response_type: "token",
      prompt: "select_account",
      redirect_uri: window.location.origin,
      scope: _.get(SCOPES, serviceType),
    });

    const getSingleParam = (value, key) =>
      `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

    const params = _.join(_.map(queryParams, getSingleParam), "&");
    return `${_.get(BASE_URLS, serviceType)}?${params}`;
  };

  // * Third party auth request URL generator, with service type specific query params
  const SERVICES = {
    GOOGLE: {
      requestURL: () => {
        const googleQueryParams = {
          client_id: GOOGLE_CLIENT_ID,
          cookiePolicy: "single_host_origin",
          state: new URLSearchParams(commonStateParams).toString(),
        };
        return generateURL(googleQueryParams);
      },
    },
    MICROSOFT: {
      requestURL: () => {
        const microsoftQueryParams = {
          client_id: MICROSOFT_CLIENT_ID,
          state: new URLSearchParams(commonStateParams).toString(),
        };
        return generateURL(microsoftQueryParams);
      },
    },
  };

  const requestURL = _.get(SERVICES, [serviceType, "requestURL"]);
  // eslint-disable-next-line no-restricted-properties
  if (_.isFunction(requestURL)) window.open(requestURL(), "_self");
};

export const setUnderMaintenanceState = ({ value }) => {
  store.dispatch(setUnderMaintenance(value));
};

export const sentralPortalFeatureMapping = {
  ESF_SENTRAL_WELLBEING: "wellbeing",
  ESF_SENTRAL_TIMETABLE: "timetable",
  ESF_SENTRAL_POLICIES: "policies_and_resources",
  ESF_SENTRAL_DASHBOARD: "dashboard",
  ESF_SENTRAL_ATTENDANCE: "attendance",
  ESF_SENTRAL_STUDENT_PROFILE: "student_profile",
  ESF_SENTRAL_NEWSFEED: "newsfeed",
  ESF_SENTRAL_DAILY_NOTICE: "daily_notices",
  ESF_SENTRAL_DOCUMENTS: "documents",
  ESF_SENTRAL_PXP: "pxp",
  ESF_SENTRAL_SPORTS: "sports",
  ESF_SENTRAL_ACTIVITIES: "activities",
};

export const sentralPortalNotificationMapping = {
  ESF_SENTRAL_WELLBEING: "hasUnreadWellbeingRecords",
  ESF_SENTRAL_ATTENDANCE: "hasUnreadAttendanceRecords",
  ESF_SENTRAL_NEWSFEED: "hasUnreadNewsfeedRecords",
  ESF_SENTRAL_DAILY_NOTICE: "hasUnreadDailyNoticeRecords",
};

export const closeSentralPortalIframe = () => {
  window.parent.postMessage({ type: CLOSE_SENTRAL_PORTAL_IFRAME }, "*");
};

export const getDecodedToken = token => {
  try {
    const tokenDecodablePart = token?.split(".")[1];
    const decoded = Buffer.from(tokenDecodablePart, "base64").toString();
    const tokenJson = JSON.parse(decoded);
    return tokenJson;
  } catch (error) {
    return {};
  }
};

export const parsePipsState = state => {
  try {
    const MALFORMED_PERCENT_REGEX = /%(?![0-9A-Fa-f]{2})/g;
    const result = _.replace(state, MALFORMED_PERCENT_REGEX, '"');
    const decoded = decodeURIComponent(result);
    return JSON.parse(decoded);
  } catch (err) {
    return null;
  }
};

export const getUserIdOnPortalType = ({ state, portalType }) => {
  const { id: userId } =
    getUserInfo({ portalType }) || _.get(state, "login.userInfo", {});
  return userId;
};

// Auto-generated exports
export { stopChatWidget, getCurriculumProgramWithPlansPayload };
